<div class="max-w-4xl mx-auto py-8 px-4">
  <div class="mb-6">
    <h1 class="text-2xl font-bold text-on-surface">アクセスログダウンロード</h1>
    <p class="text-on-surface-variant mt-1">システムへのアクセス履歴（最大31日間）をCSV形式でダウンロードします。</p>
  </div>

  <mat-card class="bg-primary-container">
    <mat-card-content class="p-6">
      <form [formGroup]="dateRange" (ngSubmit)="downloadLogs()" class="flex flex-col gap-6">
        
        <!-- 期間選択 -->
        <div>
          <h2 class="text-lg font-medium mb-3">抽出期間を指定（最大31日間）</h2>
          <mat-form-field class="w-full max-w-md" appearance="outline">
            <mat-label>抽出期間</mat-label>
            <mat-date-range-input [rangePicker]="picker">
              <input matStartDate formControlName="start" placeholder="開始日">
              <input matEndDate formControlName="end" placeholder="終了日">
            </mat-date-range-input>
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
            @if (dateRange.get('start')?.hasError('required') || dateRange.get('end')?.hasError('required')) {
              <mat-error>期間を指定してください</mat-error>
            }
          </mat-form-field>
        </div>

        <!-- 抽出ボタン -->
        <div class="mt-4 pt-4 border-t border-gray-200">
          <div class="flex items-center gap-4">
            <button 
              matButton="tonal"
              type="submit" 
              [disabled]="dateRange.invalid || isDownloading()">
              <mat-icon>download</mat-icon>
              CSVダウンロード
            </button>
            @if (isDownloading()) {
              <div class="flex items-center gap-2 text-sm text-on-surface-variant">
                <mat-spinner diameter="20"></mat-spinner>
                <span>ダウンロード中...</span>
              </div>
            }
          </div>
        </div>
        
      </form>
    </mat-card-content>
  </mat-card>
</div>
